import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker"
import ArrowSquareUp from "@assets/icons/arrowSquareUp"
import { useState } from "react"
import { cn } from "src/utils/common.helper"
import formatDateFromISOString from "src/utils/formatDate"
import dayjs from "dayjs"

const AppointmentCalendar = ({
  defaultCollapse = true,
  rootClassNameOnCollapsed,
  rootClassNameOnExpand,
  onChange,
  views = ["day", "month", "year"], // Restore all three views
  minDate,
  disablePastDates = false, // Set default to false to allow past date selection
}) => {
  const [collapseCalendar, setShowCollapseCalendar] = useState(defaultCollapse)
  const currentDate = formatDateFromISOString(new Date())

  const today = dayjs().startOf("day")
  const minDateValue = minDate ? dayjs(minDate) : null // Remove 'today' as default minDate

  return (
    <div
      className={cn(
        `bg-[--pure-white] ${
          collapseCalendar
            ? "max-h-[9.8rem] min-h-[9.8rem] overflow-y-auto " +
              rootClassNameOnCollapsed
            : "min-h-max " + rootClassNameOnExpand
        } no-scrollbar pt-4 rounded-2xl border border-[#C4E2FF] md:border-0`
      )}
    >
      <div className="flex font-[Poppins] justify-between px-6 h-[4.12rem]">
        <div className="flex gap-2 items-center">
          <div className="text-[--primary-blue] text-4xl font-medium">
            {currentDate.day}
          </div>
          <div>
            <div className="text-[#100F14] text-sm font-medium">
              {currentDate.specificMonthName}
            </div>
            <div className="text-[#100F14] text-sm font-medium">
              {currentDate.year}
            </div>
          </div>
        </div>
        <button
          onClick={() => {
            setShowCollapseCalendar((previous) => !previous)
          }}
        >
          <ArrowSquareUp />
        </button>
      </div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer
          components={["StaticDatePicker"]}
          sx={{
            borderRadius: "16px",
          }}
        >
          <DemoItem>
            <StaticDatePicker
              defaultValue={today}
              views={views}
              openTo="day" // Always open to day view initially
              onChange={(newValue) => {
                if (newValue && typeof newValue.toDate === "function") {
                  const pickedDate = newValue.toDate();
                  const now = new Date();            
                  // Set time from current time
                  pickedDate.setHours(now.getHours());
                  pickedDate.setMinutes(now.getMinutes());
                  pickedDate.setSeconds(now.getSeconds());
                  pickedDate.setMilliseconds(now.getMilliseconds());
                  onChange(pickedDate);
                }
              }}
              minDate={minDateValue} // This will be null, allowing all past dates
              shouldDisableDate={(date) => {
                if (disablePastDates) {
                  return date.isBefore(today)
                }
                return false
              }}
              sx={{
                ".MuiDayCalendar-weekDayLabel": {
                  color: "#BCBEC0",
                  fontSize: "20px",
                },
                ".MuiPickersDay-root": {
                  fontSize: "16px",
                  fontFamily: "Roboto",
                },
                ".MuiPickersDay-today": {
                  border: "0",
                },
                ".MuiPickersCalendarHeader-label": {
                  color: "#49454F",
                  fontSize: "14px",
                  fontWeight: "500",
                  fontFamily: "Roboto",
                },
                ".MuiPickersCalendarHeader-root": {
                  minHeight: "4rem",
                  marginTop: "0",
                },
                ".MuiPickersToolbar-root": {
                  display: "none",
                },
                ".MuiYearCalendar-root": {
                  "&::-webkit-scrollbar": {
                    width: "0px",
                    height: "0px",
                  },
                },
              }}
              orientation="portrait"
              slots={{
                actionBar: () => null,
              }}
            />
          </DemoItem>
        </DemoContainer>
      </LocalizationProvider>
    </div>
  )
}

export default AppointmentCalendar
